<template>
  <div class="popover-toolbar">
    <ConnectionStatus :deviceId="deviceId" />
    <BatteryStatus :deviceId="deviceId" />
    <EolAlert :deviceId="deviceId" />
    <DeviceAlerts :deviceId="deviceId" />
    <DeviceNotifications :deviceId="deviceId" :deviceName="name" />
    <CommunicationStatus :deviceId="deviceId" />
    <OfflineStudiesStatus :deviceId="deviceId" />
    <LiveStudiesStatus :deviceId="deviceId" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { NAMESPACES } from '@/store/types'
import { DEVICE_GETTERS } from '@/store/devices'
import EolAlert from './eolAlert.vue'
import ConnectionStatus from './connectionStatus.vue'
import DeviceAlerts from './deviceAlerts.vue'
import DeviceNotifications from './deviceNotifications.vue'
import BatteryStatus from '@/components/icons/BatteryStatus.vue'
import CommunicationStatus from '@/components/icons/CommunicationStatus.vue'
import OfflineStudiesStatus from '@/components/icons/OfflineStudiesStatus.vue'
import LiveStudiesStatus from '@/components/icons/LiveStudiesStatus.vue'

export default defineComponent({
  components: {
    DeviceAlerts,
    DeviceNotifications,
    EolAlert,
    ConnectionStatus,
    BatteryStatus,
    CommunicationStatus,
    OfflineStudiesStatus,
    LiveStudiesStatus
  },
  props: {
    deviceId: {
      type: String,
      default: ''
    }
  },
  computed: {
    name(): string {
      return this.$store.getters[`${NAMESPACES.DEVICES}/${DEVICE_GETTERS.GET_NAME_BY_DEVICE_ID}`](
        this.deviceId
      )
    }
  }
})
</script>

<style scoped lang="scss">
.popover-toolbar {
  white-space: nowrap;

  :deep(.v-icon) {
    font-size: 22px;
  }

  :deep(img) {
    width: 22px;
  }

  @media (max-width: 480px) {
    :deep(.v-icon) {
      font-size: 21px;
    }

    :deep(img) {
      width: 21px;
    }
  }
}
</style>
